"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const CardButton = (0, _styledComponents.default)(({
  primary,
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
  variant: primary ? 'contained' : 'text',
  color: primary ? 'primary' : 'secondary'
}, props), children))`
	&.MuiButton-root {
		display: flex;
		flex: 1;
		min-height: 60px;
		border-radius: 0;
	}
`;
CardButton.propTypes = {
  primary: _propTypes.default.bool
};
CardButton.defaultProps = {
  primary: false
};
var _default = CardButton;
exports.default = _default;